/**
 * ds-scroll-to-atc.js
 * Intercepts clicks on [data-scroll-to-atc] buttons and scrolls
 * smoothly to the product ATC section, accounting for the sticky header.
 */
(function () {
  function getHeaderHeight() {
    // Dawn uses a <sticky-header> custom element; fall back to header-wrapper
    var el =
      document.querySelector('sticky-header') ||
      document.querySelector('.header-wrapper') ||
      document.querySelector('header');
    return el ? el.getBoundingClientRect().height : 0;
  }

  function scrollToATC(e) {
    var btn = e.target.closest('[data-scroll-to-atc]');
    if (!btn) return;
    e.preventDefault();

    // Try the main product section first, then any product form
    var target =
      document.getElementById('MainProduct-main') ||
      document.querySelector('.product') ||
      document.querySelector('[id^="MainProduct-"]');

    if (!target) return;

    var headerH = getHeaderHeight();
    var rawTop = target.getBoundingClientRect().top + window.pageYOffset;
    var scrollTo = Math.max(0, rawTop - headerH - 8); // 8 px breathing room

    window.scrollTo({ top: scrollTo, behavior: 'smooth' });
  }

  // Attach once on DOMContentLoaded, delegate through the document
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      document.addEventListener('click', scrollToATC);
    });
  } else {
    document.addEventListener('click', scrollToATC);
  }
})();
